import {
    Box,
    Button,
    TextField,
    Typography,
    styled,
} from '../../../../../base';

const PANEL_WIDTH = 220;

export const StyledTrigger = styled(Box)<{ isopen: 'true' | 'false' }>(
    ({ theme, isopen }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(1),
        width: PANEL_WIDTH,
        minHeight: 32,
        padding: theme.spacing(0.5, 1.5),
        cursor: 'pointer',
        userSelect: 'none',
        backgroundColor: theme.palette.common.white,
        border: `1px solid ${theme.palette.secondary.main}`,
        borderRadius: theme.shape.borderRadius,
        transition: 'border-radius 0.2s ease',
        ...(isopen === 'true' && {
            borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
        }),
    })
);

export const StyledTriggerText = styled(Typography)(({ theme }) => ({
    ...theme.typography.body2,
    color: theme.palette.secondary.main,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
}));

export const StyledPanel = styled(Box)(({ theme }) => ({
    width: PANEL_WIDTH,
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey[300]}`,
    borderTop: 'none',
    borderRadius: `0 0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
}));

export const StyledSearchField = styled(TextField)(({ theme }) => ({
    width: '100%',
    padding: theme.spacing(1, 1.5),
    '& .MuiInputBase-sizeSmall.MuiOutlinedInput-root': {
        height: 34,
        borderRadius: theme.shape.borderRadius,
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.grey[300],
    },
}));

export const StyledOptionsList = styled(Box)(() => ({
    maxHeight: 220,
    overflowY: 'auto',
}));

export const StyledOptionRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.25, 1.5),
    minHeight: 40,
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
    },
}));

export const StyledOptionLabel = styled(Typography)(({ theme }) => ({
    color: theme.palette.grey[600],
    wordBreak: 'break-word',
}));

export const StyledEmpty = styled(Box)(({ theme }) => ({
    padding: theme.spacing(3, 1.5),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

export const StyledFooter = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5),
    borderTop: `1px solid ${theme.palette.grey[300]}`,
}));

export const StyledApplyButton = styled(Button)(({ theme }) => ({
    flex: 1,
    minHeight: 30,
    borderRadius: theme.spacing(2),
    textTransform: 'none',
    fontWeight: 700,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
    },
}));

export const StyledCancelButton = styled(Button)(({ theme }) => ({
    flex: 1,
    minHeight: 30,
    borderRadius: theme.spacing(2),
    textTransform: 'none',
    fontWeight: 600,
    color: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.secondary.main}`,
    '&:hover': {
        backgroundColor: theme.palette.secondary.light,
        border: `1px solid ${theme.palette.secondary.main}`,
    },
}));
